import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../LoginContainer/styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'

import { redirectToPage } from 'srcReact/helpers/history'

function OrgSelection({
  isNative,
  setCurrentStep,
  currentState,
  setCurrentState,
  organizations,
  workplaceInvitationCount,
  idps,
  isRegistered
}) {
  const { t } = useTranslation()

  const handleBack = () => {
    setCurrentStep('email')
  }

  const handleSignInOrg = (idp, org) => {
    setCurrentState({
      ...currentState,
      selectedOrgId: org.id
    })
    if (idp && idp.login_url) {
      //these location storage values will be used in PrivateRoute to do relogin
      localStorage.setItem('ssoEmail', currentState.email)
      localStorage.setItem('ssoOrgId', org.id.toString())
      window.location = `${idp.login_url}?organization_id=${org.id}`
    } else {
      if (org.is_organization_member === 1) {
        setCurrentStep('password')
      } else {
        if (isRegistered) {
          const isOrganizerMemberOfAtleastOne = organizations.some(
            (x) => x.is_organization_member === 1 && x.idp_id === 1
          )
          if (isOrganizerMemberOfAtleastOne) {
            setCurrentStep('password')
          } else {
            setCurrentStep('confirm-password')
          }
        } else {
          redirectToPage(`/0/signup?step=email&orgid=${org.id}`, isNative)
        }
      }
    }
  }

  return (
    <div className={styles.orgSelectionContainer}>
      <h1 className={parentStyles.title}>{t('login.orgSelection.title')}</h1>
      <div className={styles.organizations}>
        {organizations &&
          organizations.map((org) => {
            const idp = idps.find((i) => i.id === org.idp_id)
            return (
              <div className={styles.organization}>
                <div className={styles.orgInfo}>
                  <img className={styles.orgPicture} src={org.picture} />
                  <div className={styles.divider} />
                  <label className={styles.orgName}>{org.name}</label>
                </div>
                <Button
                  text={t('global.signin')}
                  customStyle={styles.btnSignin}
                  style='tertiary'
                  handleClick={() => handleSignInOrg(idp, org)}
                />
              </div>
            )
          })}
      </div>
      <div className={styles.buttons}>
        <Button text={t('global.back')} handleClick={handleBack} />
      </div>
    </div>
  )
}

export default OrgSelection
